var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showSuccessPage
    ? _c("div", [_c("dividends-page-success")], 1)
    : _c("div", { staticClass: "dividends-page" }, [
        _c(
          "form",
          [
            _c(
              "div",
              {
                staticClass: "dividends-page__header",
                on: {
                  click: function($event) {
                    return _vm.backToSale()
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "dividends-page__back" },
                  [
                    _c(
                      "md-icon",
                      {
                        staticClass:
                          "detail-row__clipboard-icon md-primary md-size-15"
                      },
                      [_vm._v("keyboard_arrow_left")]
                    ),
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.i18n.lbl_back_to_sale()) +
                        "\n    "
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "container-header create-sale__heading" },
                  [
                    _c("div", { staticClass: "container-header__title" }, [
                      _vm._v(_vm._s(_vm.i18n.lbl_dividends_pay()))
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "dividends-page__content dividends container container_30"
              },
              [
                _c(
                  "div",
                  { staticClass: "dividends-row dividends-row__main-info" },
                  [
                    _c("div", { staticClass: "dividends-row__name" }, [
                      _c("div", { staticClass: "dividends-row__title" }, [
                        _vm._v(_vm._s(_vm.i18n.divid_fund_name()))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "dividends-row__value" }, [
                        _vm._v(_vm._s(_vm.sale.name))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "dividends-row__tokens" }, [
                      _c("div", { staticClass: "dividends-row__title" }, [
                        _vm._v(_vm._s(_vm.i18n.divid_tokens_issued()))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "dividends-row__value" }, [
                        _vm._v(
                          _vm._s(_vm.sale.baseHardCap) +
                            " " +
                            _vm._s(_vm.sale.baseAsset)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dividends-row__investments",
                        class:
                          _vm.sale.details.internal_type === "deposit"
                            ? "dividends-row__investments_short"
                            : ""
                      },
                      [
                        _c("div", { staticClass: "dividends-row__title" }, [
                          _vm._v(_vm._s(_vm.i18n.divid_total_investments()))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "dividends-row__value" }, [
                          _vm._v(
                            "€ " +
                              _vm._s(
                                _vm.roundCurrency(
                                  _vm.sale.currentCap,
                                  _vm.sale.defaultQuoteAsset
                                )
                              )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.sale.details.internal_type === "deposit"
                      ? _c("div", { staticClass: "dividends-row__term" }, [
                          _c("div", { staticClass: "dividends-row__title" }, [
                            _vm._v(_vm._s(_vm.i18n.sale_campaign_duration()))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "dividends-row__value" }, [
                            _vm._v(
                              _vm._s(_vm.sale.details.loan_term) +
                                " " +
                                _vm._s(_vm.term)
                            )
                          ])
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _vm.sale.details.internal_type === "equity"
                  ? _c(
                      "div",
                      { staticClass: "dividends-row dividends-row__payments" },
                      [
                        _c("div", { staticClass: "dividends-row__title" }, [
                          _vm._v(_vm._s(_vm.i18n.divid_total_payments()))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "field-wrap" },
                          [
                            _c("input-field", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "field_medium-small field__number",
                              class: _vm.balanceError ? "md-invalid" : "",
                              attrs: {
                                name: "total-payments",
                                placeholder: "0",
                                id: "total-payments",
                                type: "number"
                              },
                              model: {
                                value: _vm.form.total_payments,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "total_payments", $$v)
                                },
                                expression: "form.total_payments"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "field-icon" }, [
                              _vm._v("€")
                            ]),
                            _vm._v(" "),
                            _vm.balanceError
                              ? _c(
                                  "div",
                                  { staticClass: "field-wrap__error" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.i18n.tx_greater_than_balance())
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "description-block" },
                          [
                            _c("md-icon", {
                              staticClass: "description-block__icon",
                              attrs: { "md-src": "/static/img/info_icon.svg" }
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "description-block__text" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.i18n.divid_payments_description()
                                    )
                                  )
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "dividends-row investors" }, [
                  _c("div", { staticClass: "dividends-row__title" }, [
                    _vm._v(_vm._s(_vm.i18n.divid_investors_list()))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "investors__row-titles" }, [
                    _c(
                      "div",
                      { staticClass: "investors__row-title title-email" },
                      [_vm._v(_vm._s(_vm.i18n.lbl_email_2()))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "investors__row-title title-tokens" },
                      [_vm._v(_vm._s(_vm.i18n.lbl_tokens_assets()))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "investors__row-title title-dividends" },
                      [_vm._v(_vm._s(_vm.i18n.divid_to_pay()))]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "dividends-row dividends-row__investors-list investors-list md-scrollbar"
                  },
                  _vm._l(_vm.ownersList, function(item) {
                    return _c("div", { staticClass: "investors-list__row" }, [
                      _c("div", { staticClass: "investors-list__email" }, [
                        _vm._v(_vm._s(item.email))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "investors-list__tokens" }, [
                        _vm._v(_vm._s(item.amount / 1000000))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "investors-list__dividends" }, [
                        _vm._v("€ " + _vm._s(_vm.calculate(item.amount)))
                      ])
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dividends-row dividends-row__footer" },
                  [
                    _c("div", { staticClass: "footer-values" }, [
                      _c("div", { staticClass: "footer-values__item" }, [
                        _c("span", { staticClass: "footer-values__text" }, [
                          _vm._v(_vm._s(_vm.i18n.divid_total_pay()))
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "footer-values__value total" },
                          [
                            _vm._v(
                              "€ " +
                                _vm._s(
                                  _vm.roundCurrency(
                                    _vm.payoutAmount,
                                    _vm.sale.defaultQuoteAsset
                                  )
                                )
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "footer-values__item" }, [
                        _c("span", { staticClass: "footer-values__text" }, [
                          _vm._v(_vm._s(_vm.i18n.divid_your_balance()))
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "footer-values__value balance" },
                          [
                            _vm._v(
                              " € " +
                                _vm._s(
                                  _vm.roundCurrency(
                                    _vm.currentBalance,
                                    _vm.sale.defaultQuoteAsset
                                  )
                                )
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "btn-wrap" },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "btn md-primary",
                            attrs: { disabled: _vm.balanceError },
                            on: {
                              click: function($event) {
                                return _vm.showPopupMain()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.i18n.divid_pay_btn()))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "description-block" },
                      [
                        _c("md-icon", {
                          staticClass: "description-block__icon",
                          attrs: { "md-src": "/static/img/info_icon.svg" }
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "div",
                            { staticClass: "description-block__text" },
                            [
                              _vm._v(
                                _vm._s(_vm.i18n.divid_footer_description())
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _vm.showPopup
              ? _c("main-popup", {
                  attrs: {
                    showPopup: _vm.showPopup,
                    closeByClick: false,
                    confirmAction: true,
                    cancelAction: true,
                    actionsText: {
                      confirm: _vm.i18n.lbl_accept(),
                      cancel: _vm.i18n.lbl_cancel()
                    },
                    title: _vm.i18n.divid_accept_pay(),
                    subTitle: _vm.i18n.divid_will_debited({
                      amount: this.roundCurrency(
                        this.payoutAmount,
                        this.sale.defaultQuoteAsset
                      ),
                      currency: "€"
                    }),
                    text: _vm.i18n.divid_can_search(),
                    disabled: _vm.isLoading
                  },
                  on: {
                    "close-popup": _vm.closePopup,
                    "submit-popup-event": function($event) {
                      return _vm.submitDividendsHandle()
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d1dc19a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d1dc19a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/sale_details/components/Sales.DividendsPage.vue
// module id = zY/+
// module chunks = 1